export default __webpack_public_path__ + "static/media/golo-no.a7a43558.png";